import React, { useState } from "react";
import { containerStyle } from "../../styles/styles";
import { TableStyles } from "../../styles/table";
import LocalBarIcon from "@material-ui/icons/LocalBar";
import { axiosInstance } from "../../../utils/axiosInstance";
import { useDispatch } from "react-redux";
import { fetchProviders } from "../../../store/planProviders";
import ReusablePlanModal from "../../uis/modals/ReusablePlanModal";
import Button from "../../common/Button";
import HealthPlansTable from "../../uis/healthPlanTable/approvedTable";
import { fetchHealthPlans } from "../../../store/healthPlan";

                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
const HealthPlans = () => {
  const classes = containerStyle();
  const tabClasses = TableStyles();

  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    mode: null,
    providerData: null,
  });
 
  const dispatch = useDispatch();


  const handleCreatePlanProvider = async (id, data) => {
    try {
      const response = await axiosInstance.post(`/v1/admin/healthplans`, data);
      if(response.status){

        dispatch(fetchHealthPlans(10, 1)); // Refresh table
      }
    } catch (error) {
      console.error("Error creating health plan:", error);
      throw error; // Let modal handle error
    }
  };

  const handleEditPlanProvider = async (id, data) => {
    try {
      const response = await axiosInstance.put(
        `/v1/admin/healthplans/${id}`,
        data
      );
      console.log("Health Plan updated successfully:", response.data);
      dispatch(fetchProviders(10, 1)); // Refresh table
    } catch (error) {
      console.error("Error updating health plan:", error);
      throw error; // Let modal handle error
    }
  };

  const openModal = (mode, providerData) => {
    setModalConfig({
      isOpen: true,
      mode,
      providerData,
    });
  };

  const closeModal = () => {
    setModalConfig({ isOpen: false, mode: null, providerData: null });
  };

  return (
    <>
      <div className={tabClasses.filterContainer}>
        <p>
          <LocalBarIcon /> Filter by:
        </p>
        <Button onClick={() => openModal("create", {})}>
          {" "}
          Create Health Plan
        </Button>
      </div>
      <div className={classes.main}>
        <div className={tabClasses.tableRoot}>
          <div className={tabClasses.tabPanelContainer}>
            <HealthPlansTable openModal={openModal} closeModal={closeModal} />
          </div>
          <ReusablePlanModal
            isOpen={modalConfig.isOpen}
            onClose={closeModal}
            mode={modalConfig.mode}
            providerData={modalConfig.providerData}
            onSubmit={
              modalConfig.mode === "create"
                ? handleCreatePlanProvider
                : handleEditPlanProvider
            }
          />
        </div>
      </div>
    </>
  );
};

export default HealthPlans;
